import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "train"
const TrainIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.25 13.5C9.078 13.5 9.75 14.172 9.75 15H7.5V13.5zM16.5 15H14.25C14.25 14.172 14.922 13.5 15.75 13.5H16.5z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C14.578 1.5 16.463 1.975 17.654 2.413 18.896 2.87 19.5 4.078 19.5 5.25V14.197C19.5 15.26 19.11 16.402 18.16 17.1L22.281 21.22C22.572 21.513 22.572 21.987 22.28 22.28 21.986 22.573 21.512 22.573 21.22 22.28L20.69 21.75H3.31L2.78 22.28C2.487 22.573 2.013 22.573 1.72 22.28S1.427 21.513 1.72 21.22L5.838 17.1C4.89 16.403 4.5 15.26 4.5 14.197V5.25C4.5 4.078 5.104 2.87 6.346 2.413 7.536 1.975 9.422 1.5 12 1.5M4.81 20.25H19.19L17.69 18.75H6.31zM18 11.702Q17.69 11.829 17.3 11.962C16.102 12.36 14.335 12.75 12 12.75S7.897 12.36 6.7 11.961Q6.31 11.83 6 11.701V14.198C6 15.014 6.323 15.679 6.883 15.997 7.89 16.568 9.594 17.25 12 17.25S16.109 16.569 17.117 15.996C17.677 15.68 18 15.014 18 14.196zM6 10.059 6.007 10.064C6.26 10.189 6.647 10.364 7.175 10.539 8.227 10.889 9.835 11.25 12 11.25S15.773 10.89 16.825 10.539C17.352 10.363 17.741 10.189 17.993 10.063L18 10.06V6H6zM12 3C9.61 3 7.9 3.44 6.864 3.82 6.554 3.935 6.304 4.175 6.155 4.5H17.845C17.695 4.175 17.446 3.935 17.135 3.82 16.1 3.44 14.39 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default TrainIcon
